import React from 'react';
import type { FC } from 'react';

import { TrashIcon } from '@heroicons/react/24/outline';

import type { LinkedLayer } from '@/api/types';
import { LayerIcon } from '@/common/layer-icon';
import { useTemplateEditorStore } from '../store';

interface LayerCardProps {
    layer: LinkedLayer;
    onEdit: () => void;
    onDelete: () => void;
}

export const LayerCard: FC<LayerCardProps> = ({ layer, onEdit, onDelete }) => {
    const varirants = useTemplateEditorStore((s) => s.template?.variants);

    const getVariantName = (variantId: number) => {
        const variant = varirants?.find((v) => v.id === variantId);
        return variant?.name || '';
    };

    return (
        <div className="bg-gray-130 rounded align-top flex flex-col gap-2">
            <div className="bg-gray-130 p-3 rounded align-top flex flex-row gap-2 items-start">
                <LayerIcon className="flex-shrink-0 size-4 mt-1" />
                <div className="flex flex-col text-sm text-white flex-grow min-w-0">
                    <p className="truncate">{layer.name}</p>
                    <p className="text-xs text-gray-110 mt-1">{getVariantName(layer.variant)}</p>
                </div>
                <TrashIcon
                    className="flex-shrink-0 size-4 mt-1 stroke-red-50 cursor-pointer"
                    onClick={onDelete}
                    onKeyDown={onDelete}
                />
            </div>
        </div>
    );
};
